export const StripeVerificationSessionAdminFilterKey = {
  StripeSessionId: 'stripeSessionId',
} as const;

export type StripeVerificationSessionAdminFilterKey =
  (typeof StripeVerificationSessionAdminFilterKey)[keyof typeof StripeVerificationSessionAdminFilterKey];

export const STRIPE_VERIFICATION_SESSION_ADMIN_FILTER_KEYS = [
  StripeVerificationSessionAdminFilterKey.StripeSessionId,
] as const;
